import { render, staticRenderFns } from "./PublicationHabeasData.vue?vue&type=template&id=0c8eb456&scoped=true"
import script from "./PublicationHabeasData.vue?vue&type=script&lang=js"
export * from "./PublicationHabeasData.vue?vue&type=script&lang=js"
import style0 from "./PublicationHabeasData.vue?vue&type=style&index=0&id=0c8eb456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8eb456",
  null
  
)

export default component.exports